import moment from 'moment';

// Composite key used to index priceTemplate rows for O(1) lookup per cell,
// avoiding a full array scan + moment() parse inside every RateAvailabilityBox.
export const buildPriceKey = (pricelistId, roomCategoryId, packageId, rateCodeId, dateKey) =>
    `${pricelistId}|${roomCategoryId}|${packageId}|${rateCodeId}|${dateKey}`;

export const buildPriceIndex = (pricetemplate) => {
    const index = new Map();
    if (!pricetemplate) {
        return index;
    }
    for (let i = 0; i < pricetemplate.length; i++) {
        const pt = pricetemplate[i];
        const dateKey = moment(pt.hotelDate).format('YYYY-MM-DD');
        index.set(buildPriceKey(pt.pricelistId, pt.roomCategoryId, pt.packageId, pt.rateCodeId, dateKey), pt);
    }
    return index;
};
